
import { nanoid } from "nanoid";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { cleanRegisterUser, startRegisterUserAndRoleClient } from "../../app/actions/authActions";
import { schemaValidateUserRegister } from "../../app/data/schemaValidateUserRegister";
import { debugLogPages } from "../../app/helpers/debugHelper";
import { formatToTwoDigits } from "../../app/helpers/formatToTwoDigits";
import useFormValidationsGeneric from "../../app/hooks/useFormValidationsGeneric";
import NewInputGenericRegister from "../generic-component/NewInputGenericRegister";
import NewInputGenericRegisterPassword from "../generic-component/NewInputGenericRegisterPassword";
import { useEffect, useState } from "react";
import { fetchNoToken } from "../../app/helpers/fetch";
import { const_routes } from "../../app/helpers/const_routes";
import { DEFAULT_PHONE_PREFIX, nationalLengthFor, normalizeNationalNumber } from "../../app/data/phoneCountryPrefixes";
import Swal from "sweetalert2";
import RegisterMobilePrefixInput from "../generic-component/RegisterMobilePrefixInput";

const RegisterUserLogin = () => {
  debugLogPages('---> RegisterUserLogin');

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [passwordHint, setPasswordHint] = useState(false);

  const showPasswordHint = () => setPasswordHint(true);
  const hidePasswordHint = () => {
    setTimeout(() => {
      const activeId = document.activeElement && document.activeElement.id;
      if (activeId === "password" || activeId === "password_repeat") return;
      setPasswordHint(false);
    }, 0);
  };
  const { userSelected } = useSelector((state) => state.user);

   const { isSuccessRegister } = useSelector((state) => state.auth);
  const registerMobilePrefixEnabled = useSelector((state) => state.configuration.registerMobilePrefixEnabled);
  const [prefixEnabled, setPrefixEnabled] = useState(String(registerMobilePrefixEnabled) !== 'false');
  const [mobilePrefix, setMobilePrefix] = useState(DEFAULT_PHONE_PREFIX);

  const { values, errors, handleChange, handleSubmit, setValues } = useFormValidationsGeneric(
    () => registerCallback(),
    userSelected,
    schemaValidateUserRegister
  );

  useEffect(() => {
    if(isSuccessRegister === true){
      dispatch(cleanRegisterUser())
    }
  }, [])

  useEffect(() => {
    let cancelled = false;
    const loadPrefixFlag = async () => {
      try {
        const resp = await fetchNoToken(
          `${const_routes.SCHEMA}`,
          `${const_routes.VERSIONV1}`,
          `${const_routes.ROUTE_CONFIGURATION}`,
          'public/register-mobile-prefix'
        );
        const body = await resp.json();
        if (!cancelled && body.ok) {
          setPrefixEnabled(body.enabled === true);
        }
      } catch (error) {
        debugLogPages(':: RegisterUserLogin prefix flag', { error });
      }
    };
    loadPrefixFlag();
    return () => {
      cancelled = true;
    };
  }, []);

  useEffect(() => {
    if(isSuccessRegister === true){
      setValues({});
      dispatch(cleanRegisterUser())
    }
  }, [isSuccessRegister])
  

  function registerCallback() {
    let valuesSubmit = { ...values };

    const id_generated = nanoid();

    const dateNow = new Date();
    const yearFormat = dateNow.getFullYear();
    const monthFormat = formatToTwoDigits(dateNow.getMonth() + 1);
    const dayFormat = formatToTwoDigits(dateNow.getDate());
    const hoursFormat = formatToTwoDigits(dateNow.getHours());
    const minutesFormat = formatToTwoDigits(dateNow.getMinutes());
    const secondsFormat = formatToTwoDigits(dateNow.getSeconds());

    const varDateFormat = yearFormat + monthFormat + dayFormat + hoursFormat + minutesFormat + secondsFormat;

    valuesSubmit.blocked = false;
    valuesSubmit.deleted = false;
    valuesSubmit.can_login = true;
    valuesSubmit.logged_in = false;
    valuesSubmit.last_password_change = null;
    valuesSubmit.lang = "es";
    valuesSubmit.last_access_ip = null;
    valuesSubmit.last_login = null;
    valuesSubmit.gender = null;
    valuesSubmit.document = null;
    valuesSubmit.enrollment_channel = "frontend";
    if (prefixEnabled && mobilePrefix?.dial) {
      const digits = normalizeNationalNumber(valuesSubmit.mobile_number, mobilePrefix);
      const { min, max } = nationalLengthFor(mobilePrefix);
      if (digits.length < min || digits.length > max) {
        Swal.fire(
          t("titles.error"),
          t("register.screen.mobile_length", { min, max, country: mobilePrefix.name }),
          "error"
        );
        return;
      }
      valuesSubmit.mobile_number = `${mobilePrefix.dial}${digits}`;
    }

    debugLogPages(':: registerCallback, valuesSubmit', {valuesSubmit});
    dispatch(startRegisterUserAndRoleClient(valuesSubmit, id_generated + varDateFormat));
  }

  return (
    <div className="gradient-custom-sky">
      <div className="container py-5 h-100">
        <div className="row d-flex justify-content-center align-items-center h-100">
          {/*<div className="col-12 col-md-8 col-lg-10 col-xl-5">*/}
           <div className="col-12 col-md-10 col-lg-10 col-xl-8">
            <div className="bg-color2 text-white" style={{ borderRadius: "1rem" }}>
              <form onSubmit={handleSubmit} noValidate>
                <div className="card-body p-5 text-center">
                  <div className="mb-md-5 mt-md-4 pb-5">
                    <h2 className="fw-bold mb-2 text-uppercase">{t("register.screen.title")}</h2>
                    <p className="text-white-50 mb-5">{t("register.screen.message")}</p>

                    <div className="row">
                      {/** Inicio formulario dinamico */}

                      {
                        schemaValidateUserRegister && schemaValidateUserRegister.length > 0 && (
                          schemaValidateUserRegister.map((techSecondary, index) => {

                            let varField = techSecondary.field;

                            if (techSecondary.field === "mobile_number" && prefixEnabled) {
                              return (
                                <RegisterMobilePrefixInput
                                  key={techSecondary.id}
                                  handleChange={handleChange}
                                  values={values}
                                  errors={errors}
                                  field={varField}
                                  max_length={techSecondary.max_length}
                                  moduleText={techSecondary.module_text}
                                  occupation={techSecondary.occupation_new}
                                  isRequired={techSecondary.is_required}
                                  prefix={mobilePrefix}
                                  onPrefixChange={setMobilePrefix}
                                  setValues={setValues}
                                />
                              );
                            } else if (techSecondary.component_new === "NewInputGenericRegister") {
                              return (
                                <NewInputGenericRegister
                                  key={techSecondary.id}
                                  handleChange={handleChange}
                                  values={values}
                                  errors={errors}
                                  placeholderVal={techSecondary.is_placeholder}
                                  field={varField}
                                  max_length={techSecondary.max_length}
                                  moduleText={techSecondary.module_text}
                                  occupation={techSecondary.occupation_new}
                                  isRequired={techSecondary.is_required}
                                  digitsOnly={varField === "phone_number"}
                                  maxDigits={15}
                                />
                              );
                            } else if (techSecondary.component_new === "NewInputGenericRegisterPassword") {
                              return (
                                <NewInputGenericRegisterPassword
                                  key={techSecondary.id}
                                  handleChange={handleChange}
                                  values={values}
                                  errors={errors}
                                  placeholderVal={techSecondary.is_placeholder}
                                  field={varField}
                                  max_length={techSecondary.max_length}
                                  moduleText={techSecondary.module_text}
                                  occupation={techSecondary.occupation_new}
                                  onFocus={varField === "password" || varField === "password_repeat" ? showPasswordHint : undefined}
                                  onBlur={varField === "password" || varField === "password_repeat" ? hidePasswordHint : undefined}
                                />
                              );
                            } else {
                              return (
                                <div>
                                </div>
                              )
                            }
                          })
                        )
                      }

                      {/** Fin formulario dinamico */}
                    </div>

                    <br />

                    <button className="btn btn-outline-light btn-lg px-5" type="submit">
                      {t("register.screen.button")}
                    </button>
                  </div>
                  <div>
                    {passwordHint && (
                      <div
                        style={{
                          textAlign: "left",
                          background: "#fff8e8",
                          color: "#3d3420",
                          border: "1px solid #f0d78c",
                          borderRadius: "8px",
                          padding: "12px 16px",
                          margin: "0 auto 16px",
                          maxWidth: "420px",
                        }}
                      >
                        <div style={{ fontWeight: 700, marginBottom: 6 }}>{t("validations.password-field")}</div>
                        <ul style={{ margin: 0, paddingLeft: "1.1rem" }}>
                          <li>{t("validations.password-required")}</li>
                          <li>{t("validations.password-uppercase")}</li>
                          <li>{t("validations.password-lowercase")}</li>
                          <li>{t("validations.password-number")}</li>
                          <li>{t("validations.password-special")}</li>
                          <li>{t("validations.password-length")}</li>
                          <li>{t("validations.password-special-permitted")}</li>
                        </ul>
                      </div>
                    )}
                    <p className="mb-0">
                      {t("register.screen.have-an-accont")}
                      <Link to="/login" className="text-white-50 fw-bold">{t("register.screen.login.link")}</Link>
                    </p>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegisterUserLogin;
